export enum PickupStatusEnum {
    NONE = 'NONE',
    SCHEDULED = 'SCHEDULED',
    CANCELLED = 'CANCELLED',
    CLOSED = 'CLOSED',
    MANIFESTED = 'MANIFESTED'
}